// src/components/About.js
import React, {useState} from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTrophy, FaCode, FaPlus } from 'react-icons/fa';

// --- ENHANCED DATA WITH ORIGINAL TEXT ---

const achievementsData = {
  title: "Realizări Notabile",
  icon: <FaTrophy />,
  items: [
    <><span className="highlight-event">Olimpiada Națională de Informatică</span>: <span className="highlight-medal-silver">Argint</span> (2022), <span className="highlight-medal-bronze">Bronz</span> (2024)</>,
    <><span className="highlight-event">Olimpiada Județeană de Informatică</span>: <span className="highlight-medal-gold">Locul I</span> (2020, 2022, 2023, 2024, 2025)</>,
    <><span className="highlight-event">Concursul ICYS 2025</span>: <span className="highlight-award">Mențiune</span></>,
    <><span className="highlight-event">Infoeducație (Etapa Județeană)</span>: <span className="highlight-medal-gold">Locul I</span> (2024, 2025)</>,
  ],
};

const skillsData = {
  title: "Aptitudini Tehnice",
  icon: <FaCode />,
  // Restructured for better rendering and animation
  categories: [
    {
      name: "Dezvoltare Backend & Algoritmică",
      skills: ["C++", "Java", "Python", "C#", "PHP"]
    },
    {
      name: "Aplicații Web & Mobile",
      skills: ["React", "React Native", "JavaScript", "HTML5", "CSS3"]
    },
    {
      name: "Baze de Date & Unelte",
      skills: ["SQL", "Firebase", "Git", "GitHub", "Visual Studio Code"]
    }
  ]
};

// --- FRAMER MOTION VARIANTS ---

const skillsContainerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08, // This creates the staggered effect
    },
  },
};

const skillItemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
    },
  },
};


// --- COMPONENTS ---

// Age calculation function (no changes)
function calculateAge(birthDate) {
  const birthday = new Date(birthDate);
  const today = new Date();
  let age = today.getFullYear() - birthday.getFullYear();
  const m = today.getMonth() - birthday.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
    age--;
  }
  return age;
}

const AccordionItem = ({ item, isOpen, onClick }) => (
  <div className={`accordion-item ${isOpen ? 'open' : ''}`}>
    <button className="accordion-title" onClick={onClick}>
      <span className="icon">{item.icon}</span>
      {item.title}
      <span className="indicator"><FaPlus /></span>
    </button>
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="content"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
          className="accordion-content"
        >
          {/* Conditional rendering based on data structure */}
          {item.title === "Realizări Notabile" ? (
            <ul>
              {item.items.map((detail, index) => (
                <li key={index}>{detail}</li>
              ))}
            </ul>
          ) : (
            <div className="skills-section">
              {item.categories.map(category => (
                <div key={category.name} className="skills-category">
                  <h4>{category.name}</h4>
                  <motion.div
                    className="skills-grid"
                    variants={skillsContainerVariants}
                    initial="hidden"
                    animate="visible"
                  >
                    {category.skills.map(skill => (
                      <motion.div key={skill} className="skill-tag" variants={skillItemVariants}>
                        {skill}
                      </motion.div>
                    ))}
                  </motion.div>
                </div>
              ))}
            </div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);


function About() {
  const age = calculateAge('2008-08-05');
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <motion.section
      id="about"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <h2>Despre Mine</h2>
      <p style={{ textAlign: 'center', maxWidth: '700px', margin: '0 auto 2rem auto' }}>
        Sunt Flavius, un băiat de {age} ani pasionat de informatică și pian. Îmi place să explorez tehnologii noi și să construiesc aplicații utile și creative.
      </p>

      <div className="achievements-container">
        {[achievementsData, skillsData].map((item, index) => (
          <AccordionItem
            key={index}
            item={item}
            isOpen={openIndex === index}
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
          />
        ))}
      </div>
    </motion.section>
  );
}

export default About;